// Angular
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * A custom validator to check that the control value does not contain any special characters, except spaces.
 *
 * @returns A hasSpecialChars ValidationError key value pair if invalid, otherwise null.
 */
export function noSpecialCharsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // Cast the AbstractControl into the actual type we know is being used.
    const controlFC = control as FormControl<string>;

    // If the control value is empty return null because there's no error.
    if (!controlFC.value) {
      return null;
    }

    // Check if the control value contains any special characters (excluding spaces and hyphens).
    const hasSpecialChars = /[^a-zA-Z0-9 -]/.test(controlFC.value);

    // If the control value contains special characters, set the validation error.
    if (hasSpecialChars) {
      return { hasSpecialChars: true };
    }

    // Otherwise the control value does not contain special characters, so return null.
    return null;
  };
}
